import { render, staticRenderFns } from "./ItemPlanExcel.vue?vue&type=template&id=dff6b1fe&scoped=true"
import script from "./ItemPlanExcel.vue?vue&type=script&lang=js"
export * from "./ItemPlanExcel.vue?vue&type=script&lang=js"
import style0 from "./ItemPlanExcel.vue?vue&type=style&index=0&id=dff6b1fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dff6b1fe",
  null
  
)

export default component.exports